import { Skill } from "./Favorite";
import { PaymentMethod } from "./Gig";
import {
  EmployeeCategory,
  WorkerEmploymentType,
  WorkerSalaryType,
} from "./Salary";

export type OrgWorker = {
  workerId: number;
  firstName: string;
  lastName: string;
  email: string | null;
  phoneNumber: string;
  personalIdentityNumber: string;
  externalId: string;
  employmentInfo: EmploymentInfo;
  workGroups: Workgroup[];
  isRegistered: boolean;
  isActive: boolean;
};

export type EmploymentInfo = {
  current: Employment;
  next: Employment;
  previous: Employment;
  endDate: string;
  startDate: string;
};

export type Workgroup = {
  id: number;
  name: string;
  type: string;
};

export type StampClockTeam = {
  workGroupId: number;
  workGroupName: string;
};

export type Employment = {
  employeeCategory: string;
  employeeNumber: number;
  employmentType: string;
  salary: number;
  salaryType: string;
  workPercentage: number;
  startDate: string;
  endDate: string;
  taxTable: number;
  paymentType: string;
  role: string;
};

export type Team = {
  id: number;
  name: string;
  companyUnitId: number;
  workers: OrgWorker[];
};

export type Unit = {
  id: number;
  name: string;
  companyEntityId: number;
  workGroups: Team[];
};

export type Entity = {
  id: number;
  name: string;
  companyId: number;
  units: Unit[];
};

export type Structure = {
  entities: Entity[];
};

export type WorkerFormData = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  personalIdentityNumber: string;
  employmentType: string | undefined;
  workGroupIds: number[];
  salaryType: string | undefined;
  salary: number;
  startDate: string | undefined;
  endDate: string | null;
  workPercentage: number | undefined;
  taxTable: number;
  paymentType: string;
  role: string;
  employeeCategory: string;
  employeeNumber: number | undefined;
  agreement?: string;
  noticeDays?: number;
  vacationDays?: number;
  workplace?: string;
};

export type Stat = {
  stat: string;
  value: number;
};

export type Document = {
  fileName: string;
  fileSize: number;
  downloadUrl: string;
};

export type WorkerProfileData = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  personalIdentityNumber: string;
  employmentType: string | undefined;
  workGroupIds: any[];
  salaryType: string | undefined;
  salary: number | undefined;
  startDate: string | undefined;
  endDate: string | null;
  description: string | undefined;
  skills: Skill[];
  stats: Stat[];
  documents: Document[];
  workPercentage: number;
  taxTable: number;
  paymentType: string;
  role: string;
  employeeCategory: string;
  employeeNumber: number | undefined;
};

export const EMPLOYMENT_TYPE_PROJECT_EMPLOYEE = "ProjectEmployee";
export const EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE = "SimflexityEmployee";
export const EMPLOYMENT_TYPE_CONSULTANT = "Consultant";
export const EMPLOYMENT_TYPE_TRAINEE = "Trainee";

export const EMPLOYMENT_TYPE_VALUES = [
  WorkerEmploymentType.EMPLOYEE,
  WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER,
  WorkerEmploymentType.INTRODUCTORY,
  EMPLOYMENT_TYPE_PROJECT_EMPLOYEE,
  EMPLOYMENT_TYPE_CONSULTANT,
  WorkerEmploymentType.TEMPORARY_WORKER,
  EMPLOYMENT_TYPE_SIMFLEXITY_EMPLOYEE,
  EMPLOYMENT_TYPE_TRAINEE,
] as const;

export const SALARY_OPTIONS: { value: WorkerSalaryType; label: string }[] = [
  { value: WorkerSalaryType.MONTHLY, label: "OrganizationalStructure.Month" },
  { value: WorkerSalaryType.HOURLY, label: "OrganizationalStructure.Hour" },
];

export const PAYMENT_TYPE_OPTIONS: { value: PaymentMethod; label: string }[] = [
  {
    value: PaymentMethod.SIMFLEXITY_PAY,
    label: "ProfileCompany.SimflexityPay",
  },
  { value: PaymentMethod.NONE, label: "ProfileCompany.OwnSalaryManagement" },
];

export const EMPLOYEE_CATEGORY_OPTIONS: {
  value: EmployeeCategory;
  label: string;
}[] = [
  {
    value: EmployeeCategory.BLUE_COLLAR,
    label: "OrganizationalStructure.BlueCollar",
  },
  {
    value: EmployeeCategory.WHITE_COLLAR,
    label: "OrganizationalStructure.WhiteCollar",
  },
  {
    value: EmployeeCategory.OWNER,
    label: "OrganizationalStructure.Owner",
  },
];
